import { styled } from '@mui/system';
import { Paper, Button } from '@mui/material';

export const FormContainer = styled('form')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

export const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 1),
  display: 'grid',
  gridGap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 2)
  }
}));

export const ProjectFieldWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'hasProject'
})(({ theme, hasProject }) => ({
  margin: '0 !important',
  height: '100%',
  [theme.breakpoints.down('sm')]: {
    height: '58px',
    '& span[style*="position: absolute"]': {
      marginTop: '20px',
      textAlign: 'left',
      left: '11px',
      bottom: '5px'
    },
    ...(hasProject && {
      '& p': {
        marginBottom: '11px'
      }
    })
  }
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
